<div class="toast-stack" *ngIf="messages.length > 0">
  <div class="toast" *ngFor="let toast of messages; let i = index" [class]="toast.level">
    <span>{{ toast.message }}</span>
    <button type="button" (click)="dismiss(i)">×</button>
  </div>
</div>
